import {
    GET_BANNER,
    GET_AABANNER,
    GET_CHBANNER,
    BA_LOADING,
    AA_LOADING,
    CH_LOADING,
    UPDATE_BANNER,
    GET_CONTACT,
    CO_LOADING,
    ADD_CONTACT,
    DELETE_CONTACT,
    BA_ERROR,
    CO_ERROR,
} from "../actions/BannersActions"

const initialState = {
    banners: [],
    contacts: [],
    loadingcontact: true,
    aabanners: [],
    chbanners:[],
    loading: true,
    aaloading: true,
    chaloading: true,
    success: true,
    addBanner: null,
    addContact: null,
    successContact: true,
};

const BannersReducer = function(state = initialState, action){
    switch (action.type) {
        case BA_LOADING: {
            return {
                ...state,
                loading: true
            }
        }
        case CO_LOADING: {
            return {
              ...state,
              loadingcontact: true
            }
        }
        case BA_ERROR: {
            return {
              ...state,
              success: false,
              successContact: false,
              loading: false,
              loadingcontact: false,
            }
        }
        case CO_ERROR: {
            return {
              ...state,
              successContact: false,
              success: false,
              loading: false,
              loadingcontact: false,
            }
        }
        case GET_BANNER: {
            return {
                ...state,
                banners: [...action.data],
                loading: false
            }
        }
        case AA_LOADING: {
            return {
                ...state,
                aaloading: true
            }
        }
        case GET_AABANNER: {
            return {
                ...state,
                aabanners: action.data,
                aaloading: false
            }
        }
        case CH_LOADING: {
            return {
                ...state,
                chloading: true
            }
        }
        case GET_CHBANNER: {
            return {
                ...state,
                chbanners: action.data,
                chloading: false
            }
        }    
        case GET_CONTACT: {
            return {
                ...state,
                contacts: [...action.data],
                loadingcontact: false
            }
        }
        case ADD_CONTACT: {
            return {
                ...state,
                addContact: action.data,
                success: true,
                loadingcontact: false,
            }
        }
        case UPDATE_BANNER: {
            return {
                ...state,
                addBanner: action.data,
                success: true,
                loading: false, 
            }
        }
        case DELETE_CONTACT: {
            return {
                ...state,
                successContact: true,
                loadingcontact: false
            }
        }
        default: {
            return state;
        }
    }
}

export default BannersReducer;
